<h5 class="= mb-4">Thank You!</h5>
    <div class="mb-3">
      Your request has been submitted to Camp Bow Wow<sup>&#174;</sup> (<b>{{ locationName }}</b>).  A Camp representative will contact you shortly to confirm.
    </div>
    <div class="mb-5">
      To save time at check-in, take a moment to double check both your profile and your Camper's profile are up-to-date.
    </div>

<footer class="footer-action mt-5">
    <button class="btn btn-block btn-outline-danger" (click)="onSave()">
      Return Home
    </button>
</footer>
